export default "<button class=\"player__panel-button\" title=\"Skip\">\n  <span class=\"icon-container\"></span>\n</button>\n"